module.exports = __webpack_public_path__ + "static/media/ETH.28bb188b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/currency/ETH.svg
// module id = 1276
// module chunks = 103